import { render, staticRenderFns } from "./TaskEvents.vue?vue&type=template&id=b554b490"
import script from "./TaskEvents.vue?vue&type=script&lang=js"
export * from "./TaskEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b554b490')) {
      api.createRecord('b554b490', component.options)
    } else {
      api.reload('b554b490', component.options)
    }
    module.hot.accept("./TaskEvents.vue?vue&type=template&id=b554b490", function () {
      api.rerender('b554b490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Task/TaskElement/TaskEvents.vue"
export default component.exports